








import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FormDynamicFieldMultiselect from '@/components/form/FormDynamicFieldMultiselect.vue';
import ColumnsFilter from '@/components/worksheets/ColumnsFilter.vue';
import { goToNativeLink } from '@/helpers/routing/links';

@Component({
    name: 'PrintMultipleWorksheets',
    components: { FormDynamicFieldMultiselect, ColumnsFilter },
})
export default class PrintMultipleWorksheets extends Vue {
    @Prop() private query: any;

    private printWorksheetNew() {
        const params = [''];

        for (const [key, value] of Object.entries(this.query)) {
            params.push(`${key}=${value}`);
        }

        goToNativeLink(`/convert/project-applied-lessons?${params.join('&')}`, true);
    }
}
